import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./checkbox.css";
import { useNavigationBar } from "../../../context/NavigationContext";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { updateChannel } from "../../../api/channels/channelServices";
import LoadingPopup from "./LoadingPopup";
import { Timestamp } from "firebase/firestore";
import { EditChannelContext } from "../../../context/EditChannelContext";

interface ChannelCertProps {
  isEdit?: boolean;
}
export default function ChanneCertification({ isEdit = false }: ChannelCertProps) {
  const editChannelContext = useContext(EditChannelContext);
  const createChannelContext = useContext(CreateChannelContext);
  const channelData = isEdit ? editChannelContext?.channelEditData : createChannelContext?.channelData;
  const loading = isEdit ? editChannelContext?.loading : createChannelContext?.loading;
  const updateChannelData = isEdit ? editChannelContext?.updateChannelEditData : createChannelContext?.updateChannelData;
  const updateDataOnServer = isEdit ? editChannelContext?.updateEditDataOnServer : createChannelContext?.updateDataOnServer;

  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  const [checkedPrimary, setCheckedPrimary] = useState(false);
  const [checkedSecondary, setCheckedSecondary] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      updateChannelData(prev => ({ ...prev, editUpdateDate: Timestamp.now() }));
    };
  }, []);

  useEffect(() => {
    setCheckedPrimary(channelData?.certifyFirst ?? false);
    setCheckedSecondary(channelData?.certifySecond ?? false);
  }, [channelData]);

  useEffect(() => {
    // setData();
    setNavProps({
      backArrow: false,
      subtitle: "Channel",
      title: "Certification",
      buttonTitle: "Done",
      filterOption: true,
      enableLink: checkedPrimary && checkedSecondary,
      //onBack: () => alert("Back Clicked"),
      //onFilter: () => {},
      onNext: () => {
        updateChannelData({
          ...channelData,
          certifyFirst: checkedPrimary,
          certifySecond: checkedSecondary,
        });
        updateDataOnServer && setTimeout(() => updateDataOnServer());
        navigate(-1);
      },
      onClose: () => {
        navigate(-1);
      },
    });
  }, [setNavProps, navigate, channelData, updateChannelData, checkedPrimary, checkedSecondary, updateDataOnServer]);

  // const updateChannels = async () => {
  //   setIsLoading(true);
  //   const { certifyFirst, certifySecond } = channelData;
  //   await updateChannel(channelData.id!, { certifyFirst, certifySecond });
  //   setIsLoading(false);
  //   navigate(-1);
  // };

  const renderDescription = (description: string) => {
    return description.split(/(\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <div className="channel-page-context">
      <LoadingPopup isLoading={loading} />
      <div className="flex flex-col">
        <div className="flex flex-col w-full mb-5">
          <div className="flex flex-col w-full pb-[15px]">
            <label className="title_inner_page">Certify Channel Content</label>
            <label className="notes_inner_page">Certify that your channel would ensure and comply with these requirements.</label>
            <div className="pt-[15px]">
              <label className="custom-checkbox mb-[15px]">
                <input
                  name="primary"
                  className="mr-5"
                  type="checkbox"
                  checked={checkedPrimary ?? false}
                  onChange={async e => {
                    setCheckedPrimary(e.target.checked);
                  }}
                />

                <span>{renderDescription("I certify that this channel's content does *NOT* contain:")}</span>
                <span className="checkmark"></span>
              </label>
              <div className="flex flex-col ml-8 gap-[10px]">
                <label className="content-rating-all-item">1. Violence or Gore</label>
                <label className="content-rating-all-item">2. Hate Speech or Discrimination</label>
                <label className="content-rating-all-item">3. Harassment or Bullying</label>
                <label className="content-rating-all-item">4. Nudity or Sexual Content</label>
                <label className="content-rating-all-item">5. Misleading Information or Spam</label>
                <label className="content-rating-all-item">6. Abusive or Exploitive Content</label>
                <label className="content-rating-all-item">7. Privacy Violation</label>
                <label className="content-rating-all-item">8. Copyright Infringement or Illegal Content</label>
              </div>
            </div>
          </div>
          <div className="thinseparator"></div>
          <div className="flex flex-col pt-[15px] pb-[15px]">
            <label className="custom-checkbox max-w-[480px]">
              <input
                name="secondary"
                className="mr-5"
                type="checkbox"
                checked={checkedSecondary ?? false}
                onChange={async e => {
                  setCheckedSecondary(e.target.checked);
                  // updateChannelData({
                  //   ...channelData,
                  //   certifySecond: e.target.checked,
                  // });
                }}
              />
              <span>
                I certify that this channel’s content is safe, accurate, respectful, legal, protects people’s privacy and follows{" "}
                <a
                  href="https://www.skarvo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => e.stopPropagation()} // 👈 prevent label toggle
                  className="font-bold text-black underline hover:text-black-light"
                >
                  Skarvo Community Guidelines.
                </a>
              </span>
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="certificate-separator"></div>
        </div>
      </div>
    </div>
  );
}
